import { ReactNode } from "react";
import { GroupByRow } from "./groupByRowTypes";
import { GroupLoadErrorContent, GroupLoadMoreContent } from "./GroupRowContent";

interface MakeRenderFullWidthRowParams {
    onLoadMore: (groupKey: string) => void;
    onRetry: (groupKey: string) => void;
}

// Multi-arg (not a single props object) so the react plugin doesn't treat this
// JSX-returning helper as a component. Returns full-width content for
// load-more/error rows; `null` for item/group-header/skeleton rows (they
// render per-column).
function renderSyntheticRowContent<TItem>(
    row: GroupByRow<TItem>,
    onLoadMore: (groupKey: string) => void,
    onRetry: (groupKey: string) => void,
): ReactNode {
    switch (row.rowType) {
        case "loadMore":
            return (
                <GroupLoadMoreContent
                    remainingCount={row.remainingCount}
                    onLoadMore={() => onLoadMore(row.groupKey)}
                />
            );
        case "loadError":
            return (
                <GroupLoadErrorContent onRetry={() => onRetry(row.groupKey)} />
            );
        default:
            return null;
    }
}

/**
 * Builds the `renderFullWidthRow` callback for ViewTable: load-more and error
 * child rows render full-width; item, group-header, and skeleton rows return
 * `null` so they render as normal per-column rows.
 */
export function makeRenderFullWidthRow<TItem>({
    onLoadMore,
    onRetry,
}: MakeRenderFullWidthRowParams): (row: GroupByRow<TItem>) => ReactNode | null {
    return (row) => renderSyntheticRowContent(row, onLoadMore, onRetry);
}
